import { Field, InputType } from 'type-graphql'
import { User } from '../user/User'

@InputType()
export abstract class ActionArgs {
  @Field(() => User, { nullable: true })
  user?: User
}
